import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuid } from 'uuid';
import { addProduct } from '../redux/products/actionCreator';

const AddProduct = () => {

    const dispatch = useDispatch();

    const [name, setName] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [category, setCategory] = useState("");
    const [stock, setStock] = useState(0);
    const [price, setPrice] = useState(0);

    const reset = () => {
      setName("")
      setThumbnail("")
      setCategory("")
      setStock(0)
      setPrice(0)
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        const data = {
            id: uuid(),
            name,
            thumbnail,
            category,
            stock,
            price
        }
         
        dispatch(addProduct(data))
       reset();

    }

    return (
        <div className="formContainer">
          <h4 className="formTitle">Add New Product</h4>
          <form className="space-y-4 text-[#534F4F]" id="lws-addProductForm" onSubmit={handleSubmit}>
         {/*    <!-- product name --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputName">Product Name</label>
              <input className="addProductInput" id="lws-inputName" type="text" required value={name} onChange={(e)=> setName(e.target.value)}/>
            </div>
          {/*   <!-- product category --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputCategory">Category</label>
              <input className="addProductInput" id="lws-inputCategory" type="text" value={category} onChange={(e)=> setCategory(e.target.value)} required />
            </div>
        {/*     <!-- product image url --> */}
            <div className="space-y-2">
              <label htmlFor="lws-inputImage">Image Url</label>
              <input className="addProductInput" id="lws-inputImage" type="text" value={thumbnail} onChange={(e)=> setThumbnail(e.target.value)} required />
            </div>
            {/* <!-- price & quantity container --> */}
            <div className="grid grid-cols-2 gap-8 pb-4">
           {/*    <!-- price --> */}
              <div className="space-y-2">
                <label htmlFor="ws-inputPrice">Price</label>
                <input className="addProductInput" type="number" id="lws-inputPrice" value={price} onChange={(e)=> setPrice(e.target.value)} required />
              </div>
       {/*        <!-- quantity --> */}
              <div className="space-y-2">
                <label htmlFor="lws-inputQuantity">Quantity</label>
                <input className="addProductInput" type="number" id="lws-inputQuantity" value={stock} onChange={(e)=> setStock(e.target.value)} required />
              </div>
            </div>
     {/*        <!-- submit button --> */}
            <button type="submit" id="lws-inputSubmit" className="submit">Add Product</button>
          </form>
        </div>
    );
};

export default AddProduct;